import {
  format as formatDateFns,
  formatDistanceToNow as formatDistanceToNowDateFns,
  isWithinInterval as isWithinIntervalDateFns,
} from 'date-fns';
import { toDate } from 'date-fns-tz';
import { da, de, nb, type Locale } from 'date-fns/locale';
import constants from '@/utils/constants';
import { useInstitutionStore } from '@/stores/institution';

type LocaleKey = 'da' | 'de' | 'no';

const LOCALES: Record<LocaleKey, Locale> = {
  da,
  de,
  no: nb,
};

// Only needed because institutionStore is still using JS
function resolveLocale(locale: string | null | undefined): Locale {
  if (locale && LOCALES.hasOwnProperty(locale)) {
    return LOCALES[locale as LocaleKey];
  }

  return da;
}

export function format(date: string | Date, formatStr: string, options?: any) {
  const institutionStore = useInstitutionStore();

  return formatDateFns(date, formatStr, {
    ...options,
    locale: resolveLocale(institutionStore.locale),
  });
}

export function formatDistanceToNow(date: Date, options: any) {
  const institutionStore = useInstitutionStore();

  return formatDistanceToNowDateFns(date, {
    ...options,
    locale: resolveLocale(institutionStore.locale),
  });
}

export function isWithinInterval(start: string, end: string) {
  const newDate = toDate(new Date(), {
    timeZone: constants.timezone,
  });

  return isWithinIntervalDateFns(newDate, {
    start: toDate(start),
    end: toDate(end),
  });
}
